import { render, staticRenderFns } from "./InsuranceSplitOrderManage.vue?vue&type=template&id=245fc74a&scoped=true"
import script from "./InsuranceSplitOrderManage.vue?vue&type=script&lang=js"
export * from "./InsuranceSplitOrderManage.vue?vue&type=script&lang=js"
import style0 from "./InsuranceSplitOrderManage.vue?vue&type=style&index=0&id=245fc74a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245fc74a",
  null
  
)

export default component.exports